import React, { useState } from 'react'

import { Card, Flex, IconButton, Text } from '@driftt/dds'
import { faAngleDown } from '@driftt/dds.icons/light/faAngleDown'
import { faAngleUp } from '@driftt/dds.icons/light/faAngleUp'

export interface ExpandableListProps {
  children: React.ReactNode
  title: string
  openByDefault?: boolean
}

const ExpandableList = ({ children }: { children: React.ReactNode }) => (
  <Flex
    gap={0}
    css={{
      padding: 0,
      '& .ExpandableListItem': {
        border: '1px solid $gray3',
        borderRadius: '0',
        '&:first-child': {
          borderTopLeftRadius: '$1',
          borderTopRightRadius: '$1'
        },
        '&:last-child': {
          borderBottomLeftRadius: '$1',
          borderBottomRightRadius: '$1'
        },
        '&:nth-child(2n)': {
          borderTop: 'none'
        }
      }
    }}
    direction="column"
    fullWidth>
    {children}
  </Flex>
)

const ExpandableListItem = ({ children, title, openByDefault = false }: ExpandableListProps) => {
  const [isOpen, setIsOpen] = useState(openByDefault)

  return (
    <Card
      className="ExpandableListItem"
      css={{
        padding: '$half $2',
        boxShadow: 'none',
        width: '100%'
      }}>
      <Card.Header>
        <Flex alignItems="center" justifyContent="space-between" fullWidth>
          <Text variant="bodyBold">{title}</Text>

          <IconButton
            icon={isOpen ? faAngleUp : faAngleDown}
            onClick={() => setIsOpen(!isOpen)}
            title={isOpen ? 'Hide' : 'Show'}
            hideTooltip
          />
        </Flex>
      </Card.Header>
      {isOpen && <Card.Content>{children}</Card.Content>}
    </Card>
  )
}

ExpandableList.Item = ExpandableListItem

export default ExpandableList
